module.exports = __webpack_public_path__ + "img/28.b26f21e3.png";